import { useEffect } from "react";
import { useLocation } from "react-router-dom";

/* Resets window scroll position to top on every route change. */
export default function ScrollToTop() {
  const { pathname } = useLocation();
  useEffect(() => {
    if (typeof window !== "undefined") {
      window.scrollTo(0, 0);
    }
  }, [pathname]);
  return null;
}
